import { api } from './api'

export interface Notification {
  id: string
  type: string
  title: string
  message: string
  link?: string
  extra_data: Record<string, any>
  read: boolean
  read_at?: string
  created_at: string
}

export interface NotificationPreferences {
  in_app_enabled: boolean
  email_enabled: boolean
  push_enabled: boolean
  desktop_enabled: boolean
  new_conversation: boolean
  conversation_assigned: boolean
  handoff_request: boolean
  mention_received: boolean
  message_received: boolean
  conversation_resolved: boolean
  daily_summary: boolean
}

export const notificationsService = {
  async listNotifications(limit = 20, offset = 0, unreadOnly = false): Promise<Notification[]> {
    const { data } = await api.get<Notification[]>('/v1/notifications', {
      params: { limit, offset, unread_only: unreadOnly }
    })
    return data
  },

  async getUnreadCount(): Promise<number> {
    const { data } = await api.get<{ count: number }>('/v1/notifications/unread-count')
    return data.count
  },

  async markAsRead(notificationId: string): Promise<void> {
    await api.post(`/v1/notifications/${notificationId}/read`)
  },

  async markAllAsRead(): Promise<void> {
    await api.post('/v1/notifications/mark-all-read')
  },

  async getPreferences(): Promise<NotificationPreferences> {
    const { data} = await api.get<NotificationPreferences>('/v1/notification-preferences')
    return data
  },

  async updatePreferences(preferences: Partial<NotificationPreferences>): Promise<NotificationPreferences> {
    const { data } = await api.put<NotificationPreferences>('/v1/notification-preferences', preferences)
    return data
  }
}
